export enum ReportRequestStatuses {
  unknown = 0,
  reportRequested = 1,
  reportRequestEnqueued = 2,
  reportRequestDequeued = 3,
  gettingReportData = 4,
  buildingReportTemplate = 5,
  renderingPdf = 6,
  uploadingReport = 7,
  requestComplete = 8,
  requestFailed = 100
}
